import { moduleProviderFactory } from 'core/providers';
import { InsuranceOrderingList, InsuranceOrderingEdit, InsuranceOrderingUpload } from 'application/insurance-ordering/pages';

(function () {
    moduleProviderFactory.application.register({
        routes: [
            {
                name: 'master.app.main.insurance-ordering',
                pattern: '/insurance-ordering',
                children: [
                    {
                        name: 'master.app.main.insurance-ordering.list',
                        pattern: '',
                        tabTitle: 'INSURANCE_ORDERING.LIST.TITLE',
                        component: InsuranceOrderingList,
                        data: {
                            title: 'INSURANCE_ORDERING.LIST.TITLE'
                        }
                    },
                    {
                        name: 'master.app.main.insurance-ordering.create',
                        pattern: '/create',
                        tabTitle: 'INSURANCE_ORDERING.CREATE.TITLE',
                        component: InsuranceOrderingEdit,
                        authorization: 'portalSection.create',
                        data: {
                            title: 'INSURANCE_ORDERING.CREATE.TITLE'
                        },
                    },
                    {
                        name: 'master.app.main.insurance-ordering.upload',
                        pattern: '/upload',
                        tabTitle: 'INSURANCE_ORDERING.UPLOAD.TITLE',
                        component: InsuranceOrderingUpload,
                        authorization: 'portalSection.create',
                        data: {
                            title: 'INSURANCE_ORDERING.UPLOAD.TITLE'
                        },
                    }  
                ]
            }
        ],
        menu : [
            {
                title: 'MENU.MASTER_DATA',
                order: 7,
                icon: 'database',
                authorization: 'administrationSection.read',
                subMenu: [
                    {
                        title: 'MENU.INSURANCE_ORDERING',
                        route: 'master.app.main.insurance-ordering.list',
                        order: 6,
                    }                    
                ]
            }
        ]
    });
})();

